import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { MwcConfigService } from 'mwc/core/config';
import { VERSION } from 'mwc/version';

const RESPONSIVE_XS = 1120;
const RESPONSIVE_SM = 1200;

@Component({
  selector: 'app-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header id="header" class="clearfix">
      <span
        mwc-icon
        class="nav-phone-icon"
        mwcType="unordered-list"
        *ngIf="isMobile"
        mwcPopoverOverlayClassName="popover-menu"
        mwcPopoverPlacement="bottomLeft"
        mwc-popover
        [mwcPopoverContent]="menu"
      ></span>

      <div mwc-row style="flex-flow: nowrap">
        <div mwc-col [mwcXs]="24" [mwcSm]="24" [mwcMd]="6" [mwcLg]="6" [mwcXl]="5" [mwcXXl]="4">
          <app-logo></app-logo>
        </div>
        <div mwc-col [mwcXs]="0" [mwcSm]="0" [mwcMd]="18" [mwcLg]="18" [mwcXl]="19" [mwcXXl]="20" class="menu-row">
          <!-- <div
            app-searchbar
            [language]="language"
            [responsive]="responsive"
            (focusChange)="onFocusChange($event)"
          ></div> -->
          <ng-container *ngIf="!isMobile" [ngTemplateOutlet]="menu"></ng-container>
        </div>
      </div>
    </header>
    <ng-template #menu>
      <ng-container *ngIf="!searching || windowWidth > 1200">
        <ng-container *ngIf="windowWidth < 1120; else narrowNavigation">
          <ul
            mwc-menu
            app-navagation
            class="menu-site"
            [responsive]="responsive"
            [page]="page"
            [isMobile]="isMobile"
            [mwcMode]="isMobile ? 'inline' : 'horizontal'"
            [mwcSelectable]="false"
            [(language)]="language"
            (languageChange)="onChangeLanguage($event)"
          ></ul>
        </ng-container>
        <ng-template #narrowNavigation>
          <ul
            mwc-menu
            app-navagation
            class="menu-site"
            [responsive]="responsive"
            [page]="page"
            [isMobile]="isMobile"
            [mwcMode]="isMobile ? 'inline' : 'horizontal'"
            [mwcSelectable]="false"
            [(language)]="language"
            (languageChange)="onChangeLanguage($event)"
          ></ul>
          <!-- <mwc-select
            mwcSize="small"
            class="version"
            style="max-width: 126px;"
            [ngModel]="currentVersion"
            (ngModelChange)="onChangeVersion($event)"
          >
            <mwc-option [mwcLabel]="currentVersion" [mwcValue]="currentVersion"></mwc-option>
            <mwc-option *ngFor="let version of oldVersionList" [mwcLabel]="version" [mwcValue]="version"></mwc-option>
          </mwc-select> -->
          <!-- <button
            mwc-button
            mwcSize="small"
            class="header-button header-lang-butto"
            (click)="onChangeLanguage(language === 'zh' ? 'en' : 'zh')"
          >
            {{ language == 'zh' ? 'English' : '中文' }}
          </button> -->
          <button
            mwc-button
            mwcGhost
            mwcSize="small"
            class="header-button header-direction-button"
            (click)="toggleDirection()"
          >
            {{ nextDirection | uppercase }}
          </button>
          <!-- <app-github-btn [responsive]="responsive"></app-github-btn> -->
        </ng-template>
      </ng-container>
    </ng-template>
  `
})
export class HeaderComponent implements OnChanges {
  @Input() language: 'zh' | 'en' = 'zh';
  @Input() windowWidth = 1400;
  @Input() page: 'docs' | 'components' | 'experimental' | string = 'docs';
  @Output() versionChange = new EventEmitter<string>();
  @Output() languageChange = new EventEmitter<'zh' | 'en'>();
  @Output() directionChange = new EventEmitter<'ltr' | 'rtl'>();

  searching = false;
  isMobile = false;
  mode = 'horizontal';
  responsive: null | 'narrow' | 'crowded' = null;
  oldVersionList = [
    '14.3.x',
    '13.4.x',
    '12.1.x',
    '11.4.x',
    '10.2.x',
    '9.3.x',
    '8.5.x',
    '7.5.x',
    '1.8.x',
    '0.7.x',
    '0.5.x'
  ];
  currentVersion = VERSION.full;
  nextDirection: 'ltr' | 'rtl' = 'rtl';

  constructor(private mwcConfigService: MwcConfigService, private cdr: ChangeDetectorRef) {}

  onChangeVersion(version: string): void {
    this.versionChange.emit(version);
  }

  onFocusChange(focus: boolean): void {
    this.searching = focus;
  }

  onChangeLanguage(language: 'en' | 'zh'): void {
    this.languageChange.emit(language);
  }

  toggleDirection(): void {
    this.directionChange.emit(this.nextDirection);
    this.mwcConfigService.set('modal', { mwcDirection: this.nextDirection });
    this.mwcConfigService.set('drawer', { mwcDirection: this.nextDirection });
    this.mwcConfigService.set('message', { mwcDirection: this.nextDirection });
    this.mwcConfigService.set('notification', { mwcDirection: this.nextDirection });
    this.mwcConfigService.set('image', { mwcDirection: this.nextDirection });
    if (this.nextDirection === 'rtl') {
      this.nextDirection = 'ltr';
    } else {
      this.nextDirection = 'rtl';
    }
    this.cdr.markForCheck();
  }

  updateResponsive(): void {
    this.responsive = null;
    this.isMobile = this.windowWidth <= 768;
    if (this.windowWidth < RESPONSIVE_XS) {
      this.responsive = 'crowded';
    } else if (this.windowWidth < RESPONSIVE_SM) {
      this.responsive = 'narrow';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { windowWidth } = changes;
    if (windowWidth) {
      this.updateResponsive();
    }
  }
}
